import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NumericEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-numeric-edit-control",
    templateUrl: "./numeric-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class NumericEditControlComponent extends AbstractEditControlComponent {
    @Input() public notation: string;
    @Input() public digitInfo: string;
    @Input() public decimals: number;
    @Input() showClear: boolean = false;

    constructor(injector: Injector) {
        super(injector);
    }
}
